// extracted by mini-css-extract-plugin
export default {"apple-pay-button":"style_apple-pay-button__bhZZN","apple-pay-button-animation":"style_apple-pay-button-animation__ZPz2a","applePayShine":"style_applePayShine__yTbts"};